import { Component, OnInit } from '@angular/core';
import { BadaService } from 'src/app/services/bada.service';
import { VehicleInfo } from 'src/app/models/vehicle-info';
import { VehicleVersion } from 'src/app/models/vehicle-version';
import { Router } from '@angular/router';
import { RoutesPathEnum } from 'src/app/app-routing.module';

@Component({
  selector: 'app-vehicle-label',
  templateUrl: './vehicle-label.component.html',
  styleUrls: ['./vehicle-label.component.css']
})
export class VehicleLabelComponent implements OnInit {
  vehicleInfo: VehicleInfo;

  constructor(private badaService: BadaService, private router: Router) { }

  ngOnInit(): void {
    /**
     * Sottoscrizione alle vehicle info nel bada service
     */
    this.badaService.vehicleInfo.subscribe(vehicleInfo => {
      this.vehicleInfo = vehicleInfo;
    });
  }


  /**
  * Click sulla versione (selezione)
  */
  onVehicleVersionClick(vehicleVersion: VehicleVersion) {
    this.badaService.vehicleVersionSelected = vehicleVersion;
    this.router.navigate([RoutesPathEnum.VehicileIdentity]);
  }

}
